export interface RaceShareResponse {
    itemType: string
    subType: string
    metadata: Metadata
    participantInfo: ParticipantInfo
    raceInfo: RaceInfo
    trackInfo: TrackInfo
    vehicleInfo: VehicleInfo
    videoAssetsInfo: VideoAssetsInfo[]
    eventInfo: EventInfo
    rankInfo: RankInfo
    exerciseInfo: ExerciseInfo2
    businessOwnerInfo: BusinessOwnerInfo
    imageAssetsInfo?: ImageAssetsInfo[]
    isOwner: boolean
    description: UserDescription[]
}

export interface Metadata {
  isAdvertisement: boolean
}
export interface ParticipantInfo {
    firstName: string
    lastName: string
    nickName: string
    participantLocale: string
    profileImage: string,
    ciamId?: string
}

export interface RaceInfo {
    raceId: string
    raceTime: number
    clockedTime: number
    penalty: number
    startTime: string
    isPublished: boolean
    maxValues: MaxValues
    driftScore?: number
    driftScoreUnit?: string
    raceName?: string

}

export interface MaxValues {
    maxOilTemp: number
    bestTime: number
    maxTransmissionTemp: number
    maxLateralAcc: number
    maxDriftAngle: number
    maxTireTemp: number
    raceGuid: string
    lapCount: number
    maxSpeed: number
    maxBrakeTorque: number
    maxGForce: number
    maxLongitudalAcc: number
    avgDriftAngle?: number
    maxDriftSpeed?: number
    totalDriftDistance?: number
    maxYawRate?:number
    maxAirTemp?:number
    maxInclineAngle?:number
}

export interface UserDescription {
    value: string
    key: string
}
export interface TrackInfo {
    trackId: string
    distance: number
    trackName: string
}

export interface VehicleInfo {
    vin: string
    headUnitType: string
    vehicleModel: string
    vehicleImageUrl: string
}

export interface VideoAssetsInfo {
    type?: string
    fileSize?: number
    url?: string
    thumbnail_url?: string
    status?: string
}

export interface EventInfo {
    eventId?: string
    eventName?: string
    eventDescription?: string
    countryCode?: string
    startDate?: number
    endDate?: number
    exerciseInfo?: ExerciseInfo
}

export interface ExerciseInfo {
    exerciseId?: string
    exerciseName?: string
    exerciseType?: string
}

export interface RankInfo {
    currentRacePersonalRank?: number
    participantRank?: number
    bestRaceAttemptNumber?: number
}

export interface ExerciseInfo2 {
    exerciseId?: string
    exerciseName?: string
    exerciseType?: string
    leaderboardUrl?: string
}

export interface BusinessOwnerInfo {
    Name?: string
    bio?: string
    profileImage?: string
}

export interface ImageAssetsInfo {
  type?: string
  fileSize?: number
  url?: string
  thumbnail_url?: any
  isSensitive?: boolean
}

export enum VIDEOS_ITEM_TYPE{
  EMOTIONAL_VIDEO = "EMOTIONAL_VIDEO",
  EMOTIONAL_ANIMATION= "EMOTIONAL_ANIMATION",
  FACECAM = "FACECAM",
  DASHCAM= "DASHCAM",
}
